import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createFileRoute, Outlet, useChildMatches } from '@tanstack/react-router';
import MainChatList from '../../../../Components/MainChatList';
import { classNames } from '../../../../Utils/classnames';
import type { RootState } from '../../../../Redux';
import { closeChatroom } from '../../../../Redux/ChatListActions';

export const Route = createFileRoute('/(main)/_layout/chats/_chats')({
  component: RouteComponent,
});

function RouteComponent() {
  const dispatch = useDispatch();
  const { activeChatId } = useSelector((state: RootState) => state.chatList);
  const childMatches = useChildMatches();
  const isShowingIndex = childMatches.length === 0;

  // Close the active chatroom if we're showing the index
  useEffect(() => {
    if (isShowingIndex && activeChatId) {
      dispatch(closeChatroom(activeChatId));
    }
  }, [activeChatId, isShowingIndex, dispatch]);

  return (
    <div className={classNames('chat-content', { 'showing-messages': !isShowingIndex })}>
      <MainChatList />
      <div className="chat-main">
        {isShowingIndex ? (
          <div className="chat-main-empty">
            <p>Select a room to view and send messages</p>
          </div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
}
